import {
  type Filter,
  type FilterId,
  FilterType,
  type StaticListFilter,
} from '../types/filters';

export const getStaticListFilter = ({
  filters,
  filterId,
}: {
  filters: Filter[];
  filterId: FilterId;
}): StaticListFilter | undefined => {
  return filters.find(
    (filter): filter is StaticListFilter =>
      filter.type === FilterType.STATIC_LIST && filter.id === filterId
  );
};
